export default __webpack_public_path__ + "static/professor-1-4d06483c8f553d7986e41c590ef4ef66.png";